import { render, staticRenderFns } from "./TeamRoundStats.vue?vue&type=template&id=456c532e&scoped=true&"
import script from "./TeamRoundStats.vue?vue&type=script&lang=js&"
export * from "./TeamRoundStats.vue?vue&type=script&lang=js&"
import style0 from "./TeamRoundStats.vue?vue&type=style&index=0&id=456c532e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c532e",
  null
  
)

export default component.exports